import { useState } from "react";

interface ReminderEditProps {
  text: string;
  date: string;
  time: string;
  onSave: (text: string, date: string, time: string) => void;
  onClose: () => void;
}

export function ReminderEdit({ text, date, time, onSave, onClose }: ReminderEditProps) {
  const [editText, setEditText] = useState(text);
  const [editDate, setEditDate] = useState(date);
  const [editTime, setEditTime] = useState(time);

  const handleSave = () => {
    const trimmed = editText.trim();
    if (!trimmed) return;
    onSave(trimmed, editDate, editTime);
  };

  return (
    <div className="container">
      <div className="header-row">
        <h1 className="header-title">Edit Reminder</h1>
        <button onClick={onClose} className="btn-close">&times;</button>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <label className="field-label" htmlFor="reminder-text">Reminder</label>
        <input
          id="reminder-text"
          value={editText}
          onChange={(e) => setEditText(e.target.value)}
          placeholder="Reminder text..."
          className="field-input"
        />
      </div>

      <div style={{ marginBottom: "16px" }}>
        <label className="field-label" htmlFor="reminder-date">Date</label>
        <input
          id="reminder-date"
          type="date"
          value={editDate}
          onChange={(e) => setEditDate(e.target.value)}
          className="field-input"
        />
      </div>

      <div style={{ marginBottom: "24px" }}>
        <label className="field-label" htmlFor="reminder-time">Time</label>
        <input
          id="reminder-time"
          type="time"
          value={editTime}
          onChange={(e) => setEditTime(e.target.value)}
          className="field-input"
        />
        <p style={{ fontSize: "13px", color: "#999", marginTop: "4px" }}>
          Defaults to midnight. Set a time to be reminded later in the day.
        </p>
      </div>

      <button
        onClick={handleSave}
        disabled={!editText.trim()}
        className="btn-primary btn-full"
      >
        Save
      </button>
    </div>
  );
}
